import React from 'react';

export default class AssessmentAptitudeResults extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		// console.log('AssessmentAptitudeResults props', this.props);
		return (
			<ul className="learning-plan-exam-results list-group">
				{this.renderQuestions()}
			</ul>
		);
	}

	renderQuestions() {
		const { results } = this.props;
		return results.map((result, idx) => {
			const { question, response, correct, rationale, context } = result;
			if (question) {
				return this.renderQuestion(
					question,
					response,
					correct,
					rationale,
					context,
					idx
				);
			}
		});
	}

	renderQuestion(question, response, correct, rationale, context, idx) {
		const { id, statement, options } = question;
		return (
			<li className="list-group-item" key={id}>
				<p style={{ fontWeight: 'bold' }}>{statement}</p>
				<div className="options">
					{options.map((option, idx) =>
						this.renderOption(option, response, idx)
					)}
				</div>
				<p className="correct-incorrect">
					{correct ? (
						<span className="correct">{I18n.t('correct')}</span>
					) : (
						<span className="incorrect">{I18n.t('incorrect')}</span>
					)}
				</p>
				<p>{rationale}</p>
			</li>
		);
	}

	renderOption(option, response, idx) {
		const { statement } = option;
		const { options = [] } = response;
		const option_id = options.length ? options[0] : {};
		const checked = option_id.id == option.id;
		return (
			<div className="option" key={idx}>
				<input type="radio" disabled checked={checked} /> {statement}
			</div>
		);
	}
}
